module.exports = __webpack_public_path__ + "img/Estadio_BBVA_Bancomer_-_Diciembre_2017.1d95600a.jpg";